import {toDateFromServer} from './formatter'
import {tourName} from './helper'

export const defaultFiltererTour = (item, filter) => {
  let checkNome = true
  let checkPrezzo = true

  // filter by name
  if (filter.nome) {
    const name = tourName(item.detailResponse.detail.name).toLowerCase()
    const filterName = filter.nome.toLowerCase()
    checkNome = name.indexOf(filterName) >= 0
  }

  // filter by price
  if (filter.prezzo) {
    const itemPrice = getItemMinPrice(item)
    checkPrezzo = itemPrice >= filter.prezzo[0] && itemPrice <= filter.prezzo[1]
  }

  return checkNome && checkPrezzo
}

export const getItemMinPrice = (item) => {
  if (!item.element.departuresDatePrice) return 0
  return item.element.departuresDatePrice.map(item => item.price.importo).reduce((totale, current) => {
    return Math.min(totale, current)
  })
}

export const defaultSorterTour = (a, b, order) => {
  if (order.prezzo) {
    return sortByMinPrice(a, b, order.prezzo === 'up')
  }
  return sortByDate(a, b, order.partenza === 'up')
}

const sortByDate = (a, b, up = true) => {
  const da = toDateFromServer(a.detailResponse.detail.departureDate.date)
  const db = toDateFromServer(b.detailResponse.detail.departureDate.date)
  return up ? da.getTime() - db.getTime() : db.getTime() - da.getTime()
}

const sortByMinPrice = (a, b, up = true) => {
  const priceA = a.element.departuresDatePrice.map(item => item.price.importo).reduce((totale, current) => {
    return Math.min(totale, current)
  })
  const priceB = b.element.departuresDatePrice.map(item => item.price.importo).reduce((totale, current) => {
    return Math.min(totale, current)
  })
  return up ? priceA - priceB : priceB - priceA
}



// WEBPACK FOOTER //
// ./src/front/utils/tourUtils.js